// import MainTef from '@/assets/tef/MainTef'
import Util from '@/assets/libs/util'
// import PaymentController from '@/assets/controllers/PaymentController'

const TIMEOUT_COUNTER_TIME = 90

let timeoutCounter = TIMEOUT_COUNTER_TIME
let timeoutInterval = null

const start = () => {
    if (!Util.isAndroidMode() && timeoutInterval === null) {
        timeoutInterval = setInterval(handleTimeoutInterval, 1000)
    }
}

const handleTimeoutInterval = () => {
    timeoutCounter--
    if (timeoutCounter === 0) {
        // MainTef.stopTransactionTef()
        // PaymentController.clearDigitalWallet()
        // clear()
    }
}

const clear = () => {
    if (!Util.isAndroidMode()) {
        clearInterval(timeoutInterval)
        timeoutInterval = null
        timeoutCounter = TIMEOUT_COUNTER_TIME
    }
}

const resetTimeout = () => {
    clear()
    start()
}

const getTimeoutCounter = () => {
    return timeoutCounter
}

export default {
    start,
    clear,
    resetTimeout,
    getTimeoutCounter
}



// WEBPACK FOOTER //
// ./src/assets/controllers/PaymentTimeoutController.js